const getDateFormatted = (unixTimestamp: number) => {
  const a = new Date(unixTimestamp * 1000);
  const localDate = a.toLocaleDateString('en-US');
  const localDateSplit = localDate.split('/');
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const year = localDateSplit[2];
  const month = months[parseInt(localDateSplit[0], 10) - 1];
  const date = localDateSplit[1];
  return `${month} ${date}, ${year}`;
};

export default getDateFormatted;
